// Checks environemnt variables to get the propper base url for course content
export const getBaseUrl = course => {
  let dataUrlBase;

  let baseUrl = process.env.REACT_APP_LOCAL_COURSES_URL;

  // Development
  if (process.env.NODE_ENV === 'development') {
    if (process.env.REACT_APP_USE_LOCAL_PROXY === 'false') {
      dataUrlBase = baseUrl;
    } else {
      dataUrlBase = `/${process.env.REACT_APP_PROXY_DATA_URL}`;
    }
  }

  // production / builds
  if (process.env.NODE_ENV === 'production') {
    dataUrlBase =
      process.env.REACT_APP_LOCAL_BUILD === 'true'
        ? `${process.env.REACT_APP_LOCAL_COURSES_URL}`
        : `${process.env.PUBLIC_URL}/courses`;
  }

  return dataUrlBase;
};

export const getAPIUrl = course => {
  return `/${process.env.REACT_APP_API}`;
};

// Checks to see if the currently URL is whitelisted as a development environment.
// Used to display features that are under development only on specific environments.
export const isWhiteListedEnvironment = course => {
  const currentURL = window.location.origin;
  let isWhitelisted;

  //Get array of comma-separated URL's from the .env
  const devDomainURLS = process.env.REACT_APP_DEVELOPMENT_DOMAINS.split(
    ','
  ).map(item => item.trim());

  // check if current URL matches URLs in REACT_APP_DEVELOPMENT_DOMAINS OR User is in Development env
  isWhitelisted =
    devDomainURLS.includes(currentURL) ||
    process.env.NODE_ENV === 'development';

  return isWhitelisted;
};
